<template>
	<header>
		<img id="title-screen-logo" width="156" height="27" src="../assets/global/header-abbvie-logo.png" />
		<img id="title-screen-hdr-title" width="381" height="52" src="../assets/global/header-title.png" />
	</header>
</template>
<style scoped>
header {
	padding: 63px 65px 9px;
}

	#title-screen-logo {
		margin-top: 18px;
	}

@media (min-height:1023px){
	header {
		padding-top: 0;
	}
}
</style>